"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeHorizontalScrollable = void 0;
const makeHorizontalScrollable = (slider) => {
    let isDown = false;
    let startX;
    let scrollLeft;
    slider.onmousedown = (e) => {
        isDown = true;
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
    };
    slider.onmouseleave = () => {
        isDown = false;
    };
    slider.onmouseup = () => {
        isDown = false;
    };
    slider.onmousemove = (e) => {
        if (!isDown)
            return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 2; // scroll-fast
        slider.scrollLeft = scrollLeft - walk;
    };
};
exports.makeHorizontalScrollable = makeHorizontalScrollable;
//# sourceMappingURL=utils.js.map